import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { PaymentInfo } from '~types';

type Options = {
  enabled?: boolean;
};

export const useQueryGetPaymentInfo = ({ enabled = true }: Options = {}) => {
  return useQuery<PaymentInfo>(
    [QUERY_KEY.GET_PAYMENT_INFO],
    () => {
      return getRequest<PaymentInfo>({
        path: 'api/payment/info',
      });
    },
    {
      enabled: enabled && !!inMemoryJWTService.getCurrentToken(),
    },
  );
};
